import { apiEmpleo } from "../../util/ApiEmpleo";

export type TUpdateContractEmployeeValuationRequest = {
  Valoracion_Cuideo_Candidata: string;
};

const apiUpdateContractEmployeeValuation = async (
  contractId: string,
  payload: TUpdateContractEmployeeValuationRequest
) => {
  const res = await apiEmpleo.patch(
    `contracts/${contractId}/employee-valuation`,
    payload,
    {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    }
  );

  return res;
};

export { apiUpdateContractEmployeeValuation };
